/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Personal Health Record API
 * API for PHR
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";
import {
  PhrMedicalExpense,
  PhrMedicalExpenseFromJSON,
  PhrMedicalExpenseFromJSONTyped,
  PhrMedicalExpenseToJSON,
} from "./";

export const PhrMedicalExpenseNotificationTypename = "PhrMedicalExpenseNotification" as const;

/**
 *
 * @export
 * @interface PhrMedicalExpenseNotification
 */
export interface PhrMedicalExpenseNotification {
  /**
   *
   * @type {string}
   * @memberof PhrMedicalExpenseNotification
   */
  expenseYearMonth?: string;
  /**
   *
   * @type {Array<PhrMedicalExpense>}
   * @memberof PhrMedicalExpenseNotification
   */
  expenses?: Array<PhrMedicalExpense>;
  /**
   *
   * @type {string}
   * @memberof PhrMedicalExpenseNotification
   */
  importType: PhrMedicalExpenseNotificationImportTypeEnum;
  /**
   *
   * @type {Date}
   * @memberof PhrMedicalExpenseNotification
   */
  importedTime?: string;
  /**
   *
   * @type {number}
   * @memberof PhrMedicalExpenseNotification
   */
  totalAmount?: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PhrMedicalExpenseNotification
   */
  readonly __typename?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum PhrMedicalExpenseNotificationImportTypeEnum {
  Myna = "myna",
  File = "file",
}

export function PhrMedicalExpenseNotificationFromJSON(json: any): PhrMedicalExpenseNotification {
  return PhrMedicalExpenseNotificationFromJSONTyped(json, false);
}

export function PhrMedicalExpenseNotificationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PhrMedicalExpenseNotification {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PhrMedicalExpenseNotificationTypename,

    expenseYearMonth: !exists(json, "expense_year_month") ? undefined : json["expense_year_month"],
    expenses: !exists(json, "expenses") ? undefined : (json["expenses"] as Array<any>).map(PhrMedicalExpenseFromJSON),
    importType: json["import_type"],
    importedTime:
      !exists(json, "imported_time") ||
      (typeof json["imported_time"] === "string" && json["imported_time"].substring(0, 4) === "0001")
        ? undefined
        : json["imported_time"],
    totalAmount: !exists(json, "total_amount") ? undefined : json["total_amount"],
  };
}

export function PhrMedicalExpenseNotificationToJSON(object?: PhrMedicalExpenseNotification | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    expense_year_month: value.expenseYearMonth,
    expenses: value.expenses === undefined ? undefined : (value.expenses as Array<any>).map(PhrMedicalExpenseToJSON),
    import_type: value.importType,
    imported_time: value.importedTime === undefined ? undefined : tzDate(value.importedTime).format(),
    total_amount: value.totalAmount,
  };
}
